import { SAVE_SESSION_TOKEN, SET_IS_LOGGED_IN, SET_LOGIN_ALERT_TYPE } from './actionTypes';

export const saveSessionToken = ({ sessionToken }) => ({
  type: SAVE_SESSION_TOKEN,
  sessionToken,
});

export const setIsLoggedIn = ({ isLoggedIn }) => ({
  type: SET_IS_LOGGED_IN,
  session: {
    isLoggedIn,
  },
});

export const setLoginAlert = ({ alertType, isVisible }) => ({
  type: SET_LOGIN_ALERT_TYPE,
  alert: {
    alertType,
    isVisible,
  },
});
